import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedNew202511: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_new_202511",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-11-01",
  endDate: "2025-11-30",
  impressions: 23720,
  clicks: 418,
  adsSpendDollars: 1814,
  budgetDollars: 14500,
  salesDollars: 9498,
  bestEstimateRoas: 5.24,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.13,
  newCustomersAcquired: 16,
  dataAvailableAtDate: "2025-12-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
